import { createReducer } from 'service/utility';

import { SET_EMPRESA } from '../actions/appActions';


const initialState = {};

export default createReducer(initialState, {
  [SET_EMPRESA]: (state, { empresa }) => empresa,
});
